import { render } from "./BaseItemList.vue?vue&type=template&id=184f6cd4"
import script from "./BaseItemList.vue?vue&type=script&lang=js"
export * from "./BaseItemList.vue?vue&type=script&lang=js"

import "./BaseItemList.vue?vue&type=style&index=0&id=184f6cd4&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__